import React from 'react';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { colors, distances } from '../../styles/constants';

import paymentsActive from './icons/payments-active.svg';

import customersActive from './icons/customers-active.svg';

import campaignsActive from './icons/campaigns-active.svg';

import backofficeActive from './icons/backoffice-active.svg';

import ordersActive from './icons/orders-active.svg';

import settingsActive from './icons/settings-active.svg';

import reportsActive from './icons/reports-active.svg';

import partnerActive from './icons/partner-active.svg';

const iconMap = {
    payments: paymentsActive,
    reports: reportsActive,
    customers: customersActive,
    campaigns: campaignsActive,
    orders: ordersActive,
    backoffice: backofficeActive,
    settings: settingsActive,
    partner: partnerActive,
};

interface AppBarIconProps extends React.DOMAttributes<HTMLSpanElement> {
    icon: keyof typeof iconMap;
    to: string;
    title: string;
    exact?: boolean;
    className?: string;
}

const AppBarIconLink = (
    {
        icon,
        to,
        title,
        exact,
        className,
    }: AppBarIconProps
) => {
    return (
        <AppBarIconElem
            to={to}
            activeClassName="active"
            icon={iconMap[icon]}
            exact={exact || false}
            className={className}
        >
            <StyledP>{title}</StyledP>
        </AppBarIconElem>
    );
};

interface AppBarIconElemProps {
    icon: string;
}

const StyledP = styled.p`
    margin: 0;
    color: ${colors.background};
    font-size: 14px;
`;

const AppBarIconElem = styled(NavLink)<AppBarIconElemProps>`
    position: relative;
    background: transparent;
    height: 64px;
    width: 200px;
    display: block;
    text-decoration: none;
    user-select: none;
    margin: 0;
    padding: 16px 0px 16px 45%;
    line-height: 225%;
    background-image: url(${(props) => props.icon});
    background-repeat: no-repeat;
    background-position: 30%;
    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }
    &.active:hover,
    &.active {
        &:before {
            position: absolute;
            content: ' ';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: ${colors.background};
            top: 27px;
            left: 20px;
            @media (max-width: 768px) {
                left: ${distances.small};
                top: 14px;
            }
        }
    }
    @media (max-width: 768px) {
        width: 100%;
        height: 39px;
        padding: 4px 0px 4px 20%;
        background-position: 10%;
    }
`;

export default AppBarIconLink;
